var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-main"},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"display-3 mr-4"},[_vm._v("Welcome")])])])])
}]

export { render, staticRenderFns }